export enum SecondaryColors {
  LIGHT = 'light',
  GREY = 'grey',
  DARK = 'dark',
}
